export default __webpack_public_path__ + "static/media/spin-bg-5.579611eb.png";